module.exports = __webpack_public_path__ + "assets/touxiang1.6bb60b099d60c791ad4cbc74b0e857ce.png";